import { render } from "./WelcomeArtistGenre.vue?vue&type=template&id=2b689fae"
import script from "./WelcomeArtistGenre.vue?vue&type=script&lang=js"
export * from "./WelcomeArtistGenre.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__